import Moment from 'moment'

import RatingStars from '../../../components/ReusableComponents/RatingStars'
import styles from './Sidebar.module.scss'

const Sidebar = ({ data }) => {
  return (
    <div className={styles.sidebar}>
      <div className={styles.container}>
        <h2>Recent reviews</h2>
        {data.map(review => (
          <Review {...review} />
        ))}
      </div>
    </div>
  )
}

const Review = ({ rating, customerName, reviewedOn, roomNumber }) => (
  <div className={styles.rating}>
    <p className={styles.guestName}>
      <span>{customerName}</span>
      <RatingStars rating={rating} />
    </p>
    <p className={styles.moreInfo}>
      <span className={styles.date}>{Moment(reviewedOn).format('MMM DD')}</span>
      {roomNumber && (
        <>
          <span className={styles.seperator}>•</span>
          <span className={styles.date}>Room {roomNumber}</span>
        </>
      )}
    </p>
  </div>
)

export default Sidebar
